import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Colombia Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  analyticsRangeDownloadPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  exportPDFInAnalytics: false,
  isShipmentGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2014-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("colombiaImportLatestArrivalDate"),
    getSearchResult: getApiUrl("colombiaImportSearch"),
    getAnalyticsData: getApiUrl("analytics/colombiaImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_colombia_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_colombia_imports"),
    getShipmentByID: getApiUrl("colombiaImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfColombiaImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/colombiaImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchColombiaImportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.co_import.country_small,
  countryCaps: globalCountryDetails.co_import.country_caps,
  product_id: globalCountryDetails.co_import.product_id,
  compare_product_id: globalCountryDetails.co_import.compareProduct,
  country_CamelCase: globalCountryDetails.co_import.product_id,
  countryCode: globalCountryDetails.co_import.countryCode,
  countryType: globalCountryDetails.co_import.countryType,
  manyCountryType: globalCountryDetails.co_import.manyCountryType,
  countryTypeCode: globalCountryDetails.co_import.countryTypeCode,
  redirectionID: globalCountryDetails.co_import.redirectionID,
  analyticsCountryID: globalCountryDetails.co_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: true,
    datePicker: false,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
  },
  searchCategoryList: globalCountryDetails.co_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    countryOfOriginRegion: "countryOfOriginRegion",
    countryOfPurchaseRegion: "countryOfPurchaseRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfShipper: "countryOfShipper",
    shipperCity: "shipperCity",
    consignee: "consignee",
    destinationDepartment: "destinationDepartment",
    standardUnladingPortName: "standardUnladingPortName",
    modeOfTransport: "modeOfTransport",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    derivedShipperMasterName: "derivedShipperMasterName",
    shipperName: "shipperName",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfOriginRegion: "countryOfOrigin",
    countryOfPurchaseRegion: "countryOfPurchase",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfOriginRegion: [],
    countryOfPurchaseRegion: [],
    countryOfDestinationRegion: [],
    countryOfShipper: [],
    shipperCity: [],
    consignee: [],
    destinationDepartment: [],
    standardUnladingPortName: [],
    modeOfTransport: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    derivedShipperMasterName: [],
    shipperName: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfOriginRegion: false,
    countryOfPurchaseRegion: false,
    countryOfDestinationRegion: false,
    countryOfShipper: false,
    shipperCity: false,
    consignee: false,
    destinationDepartment: false,
    standardUnladingPortName: false,
    modeOfTransport: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    derivedShipperMasterName: false,
    shipperName: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "18", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Destination State", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "destinationDepartment", type: filterType.normalFilter, label: "Destination State", viewAllPlaceHolder: "Search in Destination State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "28", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper", categoryName: categoryType.shipperDetails, eventKey: "10", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search Shippers", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Origin", categoryName: categoryType.shipperDetails, eventKey: "4", key: "countryOfOriginRegion", altKey: "countryOfOrigin", type: filterType.localizeFilter, label: "Country of Origin", viewAllPlaceHolder: "Search in Country of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "6", key: "countryOfPurchaseRegion", altKey: "countryOfOrigin", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "7", key: "countryOfShipper", type: filterType.normalFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Shipper Country Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "7", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper City", categoryName: categoryType.shipperDetails, eventKey: "8", key: "shipperCity", type: filterType.normalFilter, label: "Shipper City", viewAllPlaceHolder: "Search in Shipper City Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office", categoryName: categoryType.ports, eventKey: "11", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "12", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "14", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "14", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "15", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Value (kg) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "16", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Shipment Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "hs_code", label: "HS Code" },
    { key: "colombian_entity_business_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "derived_nit_number", label: "Consignee NIT Number" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_office_name", label: "Customs Office" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "shipper_address", label: "Shipper Address" },
    { key: "consignee_address", label: "Consignee Address" },
  ],
  shipmentSorting: [
    { columnKey: "month_of_process", value: "date", isDefault: true },
    { columnKey: "net_weight_kilos", value: "weight", isDefault: false },
    { columnKey: "fob_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "month_of_process",
    weight: "net_weight_kilos",
    shipment_value: "fob_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Net Weight (kg)", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfPurchaseRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_origin", filterKey: "countryOfOriginRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_export" },
    // { key: "derived_country_of_export", filterKey: "countryOfExportRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "derived_country_of_purchase", filterKey: "countryOfPurchaseRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_exporter" },
    // { key: "derived_country_of_exporter", filterKey: "countryOfShipper", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_purchase" },
    { key: "exporter_city_name_english", filterKey: "shipperCity", label: "Shipper Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_colombia_destination_state" },
    { key: "derived_colombia_destination_state", filterKey: "destinationDepartment", label: "Destination States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "exporter_city_name_english" },
    { key: "derived_customs_office_name", filterKey: "standardUnladingPortName", label: "Customs Office", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "place_of_entry_name", filterKey: "placeOfEntry", label: "Places of Entries", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_colombia_destination_state" },
    { key: "derived_colombia_importer_state", filterKey: "consigneeDepartment", label: "Consignee States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin" },
    { key: "derived_transportation_route_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_colombia_destination_state" },
    { key: "hs_code", headerLabel: "HS Codes", filterKey: "hsCode", label: "HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    // { key: "trade_origin_country_destination_state", filterKey1: "countryOfOriginRegion", filterKey2: "destinationDepartment", label: "Trade Routes (Country of Origin → Destination State)", headerOne: "Country of Origin", headerTwo: "Destination State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: 'trade_export_country_destination_state', filterKey1: 'countryOfExportRegion', filterKey2: 'destinationDepartment', label: 'Trade Routes (Country of Export → Destination State)', headerOne: 'Country of Export', headerTwo: 'Destination State', filterOne: 'filterExportCountry', filterTwo: 'filterDestinationState', keyOne: 'countryOfExport', keyTwo: 'destinationState', keyOneCountryCode: 'exportCountryCode', type: analyticsType.topTwo, showTrends: true, grpType: 'multi', showlevelTwo: true, defaultKey: 'derived_consignee_master_name' },
    // { key: 'trade_origin_export_country_destination_state', filterKey1: 'countryOfOriginRegion', filterKey2: 'countryOfExportRegion', filterKey3: 'destinationDepartment', label: 'Trade Routes (Country of Origin → Country of Export → Destination State)', headerOne: 'Country of Origin', headerTwo: 'Country of Export', headerThree: 'Destination State', filterOne: 'filterField1', filterTwo: 'filterField2', filterThree: 'filterField3', keyOne: 'field1Country', keyTwo: 'field2Country', keyThree: 'field3Country', cityOne: 'field1', cityTwo: 'field2', cityThree: 'field3', keyOneCountryCode: 'field1CountryCode', keyTwoCountryCode: 'field2CountryCode', keyThreeCountryCode: 'field3CountryCode', type: analyticsType.topThree, showTrends: true, grpType: 'multi', showlevelTwo: true, defaultKey: 'derived_consignee_master_name' },
    // { key: "trade_exporter_city_destination_state", filterKey1: "shipperCity", filterKey2: "destinationDepartment", label: "Trade Routes (Shipper City → Destination State)", headerOne: "Shipper City", headerTwo: "Destination State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    // { key: "trade_exporter_city_importer_state", filterKey1: "shipperCity", filterKey2: "consigneeDepartment", label: "Trade Routes (Shipper City → Consignee State)", headerOne: "Shipper City", headerTwo: "Consignee State", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "month_of_process", name: "Month of Process", selector: "month_of_process", dataTip: "", type: "", dateFormat: "MMM, YYYY", sortable: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", miWidth: "100px", maWidth: "100px" },
    //{name: 'Product', selector: 'product_description', tooltipValue: 'product_description', type: '', grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40,},
    { key: "number_of_units", name: "Quantity", selector: "number_of_units", secondarySelector: "derived_unit_of_measurement_english", dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "net_weight_kilos", name: "Net Weight (kg)", selector: "net_weight_kilos", dataTip: "", type: "", sortable: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "110px", maWidth: "110px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "derived_consignee_master_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I" },
    { key: "derived_country_of_exporter", name: "Shipper Country", selector: "derived_country_of_exporter", dataTip: "", type: "" },
    { key: "cif_value_usd", name: "Shipment Value (USD)", selector: "cif_value_usd", dataTip: "", type: "", sortable: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "weight", name: "Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Month of Process", value: "month_of_process", monthFormat: true, preValidate: true },
        { label: "Import Type", value: "derived_import_type_description", tooltip: true, tooltipField: "derived_import_type_description_spanish", tooltipPrefix: "", tooltipValue: "", preValidate: true },
        { label: "Mode of Transportation", value: "derived_transportation_route_english", tooltip: true, tooltipField: "derived_transportation_route_spanish", tooltipPrefix: "", tooltipValue: "", preValidate: true },
        { label: "HS Code", value: "hs_code", preValidate: true },
        { label: "Mode of Payment", value: "derived_method_of_payment_english", preValidate: true },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin", info: "Country where the goods were actually manufactured and/or produced, or where the last substantial transformation occurred", capitalize: "true", countryFlag: true, countryCodeField: "derived_country_of_origin_code", preValidate: true },
        // { label: "Country of Export", value: "derived_country_of_export", info: "Country from where it left to the final destination, regardless of the country of origin or the final point of shipment", capitalize: "true", countryFlag: true, countryCodeField: "derived_country_of_export_code", preValidate: true },
        { label: "Country of Export", value: "derived_country_of_export", capitalize: "true", countryFlag: true, countryCodeField: "derived_country_of_export_code", preValidate: true },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "derived_shipper_master_name", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Name", value: "shipper_name", capitalize: "true", preValidate: true },
        { label: "Shipper Address", value: "shipper_address", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper City", value: "exporter_city_name_english", capitalize: "true", preValidate: true },
        { label: "Shipper Email ID", value: "derived_shipper_email", preValidate: true },
        { label: "Shipper Phone", value: "derived_shipper_phone", preValidate: true },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", capitalize: "true", countryFlag: true, countryCodeField: "derived_country_of_import_code", preValidate: true },
        { label: "Destination State", value: "derived_colombia_destination_state", tooltip: true, tooltipField: "colombia_destination_state", tooltipPrefix: "Destination State Code: ", capitalize: "true", preValidate: true },
        { label: "Place of Entry", value: "place_of_entry_name", tooltip: true, tooltipField: "place_of_entry_code", tooltipPrefix: "Place of Entry Code: ", capitalize: "true", preValidate: true },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "derived_consignee_master_name", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Name", value: "derived_consignee_master_name", capitalize: "true", preValidate: true },
        { label: "Consignee NIT Number", value: "derived_nit_number", preValidate: true },
        { label: "Consignee State", value: "derived_colombia_importer_state", capitalize: "true", preValidate: true },
        { label: "Consignee Address", value: "consignee_address", isReadMore: true, readMoreLength: 45 },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Tax Regime", value: "derived_tax_regime_english", tooltip: true, tooltipField: "regime_code", tooltipField2: "derived_tax_regime_spanish", tooltipPrefix: "Regime Code: ", preValidate: true },
        { label: "Customs Office", value: "derived_customs_office_name", tooltip: true, tooltipField: "customs_office_code", tooltipPrefix: "Customs Office Code: ", preValidate: true, type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Customs Administration", value: "derived_customs_administration", tooltip: true, tooltipField: "customs_administration_code", tooltipPrefix: "Custom Administration Code: ", preValidate: true },
      ],
    },
    {
      id: 5,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [{ label: "Carrier Name", value: "carrier_name" }],
    },
    {
      id: 6,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Gross Weight", value: "gross_weight_kilos_num", valueSuffix: " kg", valueSuffix2: " kg", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Net Weight", value: "net_weight_kilos", valueSuffix: " kg", valueSuffix2: " kg", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Quantity", value: "number_of_units", dynamicUnit: true, unitField: "derived_unit_of_measurement_english", tooltip: true, tooltipField: "number_of_units", tooltipField2: "derived_unit_of_measurement_spanish", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "FOB Value", value: "fob_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_fob_value_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance Value", value: "insurance_amount_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_insurance_amount_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Freight Value", value: "freight_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_freight_value_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Other Expenses", value: "other_expenses_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_other_expenses_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "CIF Value", value: "cif_value_usd", tooltip: true, valuePrefix: "USD ", tooltipField: "cif_value_colombian_peso", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Adjustment Value", value: "setting_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_setting_value_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Customs Value", value: "customs_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "derived_customs_value_cop", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Base Value", value: "derived_base_value_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "base_value_colombian_peso", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Tariff Percentage", value: "tariff_percentage", valueSuffix: " %", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Customs Duties", value: "derived_customs_duties_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "customs_duties_colombian_peso", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Tax on Sales", value: "tax_on_sales_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "tax_on_sales_colombian_peso", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
        { label: "Total VAT and Other Expenses", value: "derived_total_vat_other_expenses_usd", valuePrefix: "USD ", tooltip: true, tooltipField: "total_vat_other_expenses_colombian_peso", tooltipPrefix: "COP ", isCommaFormat: true, fixedValueUpto: 2, preValidate: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_origin",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    // derived_shipper_master_name:"Unique Exporters",
    derived_country_of_origin: "Countries of Origin",
    // derived_country_of_export: "Countries of Export",
    derived_country_of_purchase: "Countries of Export",
    derived_country_of_exporter: "Countries of Shipper",
    exporter_city_name_english: "Shipper Cities",
    derived_colombia_destination_state: "Destination States",
    derived_customs_office_name: "Customs Office",
    place_of_entry_name: "Places of Entry",
    derived_colombia_importer_state: "Consignee States",
    derived_transportation_route_english: "Mode of Transportation",

    trade_origin_country_destination_state: "Trade Routes (Country of Origin → Destination State)",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    trade_exporter_city_destination_state: "Trade Routes (Shipper City → Destination State)",
    trade_exporter_city_importer_state: "Trade Routes (Shipper City → Consignee State)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const ColombiaImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default ColombiaImportSearch;
